import { createSlice } from '@reduxjs/toolkit';
import { StartState } from '../types/state';

export const initialState: StartState = {
  marketingCommunicationOptIn: true,
  marketingCommunicationOptInDirty: false,
};

export const startSlice: any = createSlice({
  name: 'start',
  initialState,
  reducers: {
    setMarketingCommunicationOptIn: (state, action) => {
      state.marketingCommunicationOptIn = action.payload;
      state.marketingCommunicationOptInDirty = true;
    },
  },
});

export const { setMarketingCommunicationOptIn } = startSlice.actions;

export default startSlice.reducer;
